import { About, Timeline } from "@/components/Marketing";

export default function Projet() {
  return (
    <>
      <About />
      <Timeline />
    </>
  );
}
